import { useQuery } from "@tanstack/react-query";
import { getAllOrgStructureItems } from "../../api/apiOrgStructureItems";
import i18next from "i18next";

export function useGetOrgStructureItems(page = 1, perPage = 15, filters = {}) {
    const { isLoading, data, error } = useQuery({
        queryKey: ["orgStructureItems", page, perPage, filters, i18next.language],
        queryFn: () => getAllOrgStructureItems(page, perPage, filters),
        retry: false,
    });
    const orgStructureItems = data?.data?.items || [];
    const meta = data?.data?.meta || { current_page: 1, per_page: perPage, total: 0 };
    return { isLoading, error, orgStructureItems, meta };
}
